import React from "react";
import ReactTooltip from "react-tooltip";
import cx from "classnames";

const infoIcon = "fa-info-circle";
const warnIcon = "fa-exclamation-circle";

const tooltipIconClassNames = {
    info: infoIcon,
    warning: warnIcon,
    error: warnIcon
};

/**
 * Possible Tooltip type values.
 * @typedef TooltipType
 * @type {('info'|'warning'|'error')}
 */

/**
 * Tooltip displays a generic (inline) tooltip
 * @param {TooltipType} type The type of the tooltip. Determines the icon.
 * @param props
 * @returns {JSX.Element}
 */
export function Tooltip({ type = "info", ...props }) {
    const tooltipId = `filter-tooltip-${props?.identifier || "generic"}`;
    const tooltip = props?.tooltip || "";
    const iconClass = tooltipIconClassNames[type] || infoIcon;
    const containerClass = props?.containerClass || "";
    const place = props?.place || "right";

    return (
        <div
            className={cx("generic-tooltip", containerClass, {
                [type]: Object.keys(tooltipIconClassNames).includes(type)
            })}
        >
            <i className={["fa", iconClass].join(" ")} data-tip data-for={tooltipId} />
            <ReactTooltip id={tooltipId} effect="solid" place={place}>
                {tooltip}
            </ReactTooltip>
        </div>
    );
}
